import React, { useState, useEffect,useRef } from 'react'

// import Select from 'react-select';
import axios from 'axios';
import { toast } from 'react-toastify';
import { MDBInput } from "mdb-react-ui-kit";
import {
    Card,
    CardBody,
    Row,
    Badge,
    Table,
    Col,
    Button
   
  } from "reactstrap";
  import Select from "react-select";
import {CLIENT_LIST,UPLOAD_WORK_FLOW,SCEMA_BY_ID,CHNL_BY_SENDER } from "../../constants";
import NotificationAlert from "react-notification-alert";
import ReactDatetime from "react-datetime";
import moment from 'moment';

let initialvalues={
  title:"",
  date:"",
  uploaded_file:"",
  cname:0,
  senderid:"",
  channel:""
}

let clientsList = [];
let channelList = [{
  label:"Web" ,value:"web"},
  {label:"Email" ,value:"email"},
  {label:"SMS" ,value:"sms"},
  {label:"Whatsapp" ,value:"whatsapp"},
  {label:"RCS" ,value:"rcs"},
  {label:"IVR" ,value:"ivr"}
];
let senderids = [];
const UploadWorkFlow = (props) => {
  


  const [uploaddata,setUploadData]=useState(initialvalues)
  const notificationAlertRef = React.useRef(null);
  const [file, setFile] = useState()
  const [errors, setErrors] = useState()
  const[filterList,setFilterLst] = useState([]);
  const[schemadata,setSchemadata] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const ref = useRef();

  const userObj = localStorage.getItem("user");
  const user = JSON.parse(userObj);
  
  useEffect(() => {
    fetchdatabyid(user?.user_id)
  }, []);


 

  
  const fetchdatabyid = async (id) => {
    
    setIsLoading(true)
    clientsList = [];
   
    if (id) {
      await axios
        .post(SCEMA_BY_ID, { user_id: id })
        .then((res) => {
          setSchemadata(res?.data?.message)
          setFilterLst(res?.data?.message)
          setIsLoading(false)
          
         
        })
        .catch((e) => {console.log(e);
          let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef.current.notificationAlert(options);
        });
    }
    
  };
  const filterData = (e) =>{
    let filter = e.target.value;

     let filterdata = filterList?.filter((item,index)=>{
      return (item.title.toLowerCase().includes(filter.toLowerCase())
          ||item.channel.toLowerCase().includes(filter.toLowerCase())
          ||item.senderid.toLowerCase().includes(filter.toLowerCase())
    
      )})
      setSchemadata(filterdata)
   
    }


  function handleChange(event) {
    setFile(event.target.files[0])
  }

  
  function handleSubmit(event) {
    event.preventDefault()
    // const url = customFetch.post('/filedata');
    const isValid =validate();
    setErrors(isValid)
    if(Object.keys(isValid).length==0){
    const url = UPLOAD_WORK_FLOW;
    const formData = new FormData();
    formData.append('user_id', user?.user_id);
    formData.append('senderid', uploaddata?.senderid?.value);
    formData.append('client_id', user?.client);
    formData.append('channels_type', uploaddata?.channel?.value);
    formData.append('title', uploaddata.title);
    formData.append('date', moment(uploaddata?.date).format("DD-MM-YYYY"));
    formData.append('uploaded_file', file);


    //formData.append('uploaded_file', file.name);
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    axios.post(url, formData, config).then((response) => {
      fetchdatabyid(user?.user_id)
      let options = {};
      options = {
        place: "tr",
        message: "Uploaded Successfully",
        type: "success",

        autoDismiss: 2,
      };
      notificationAlertRef.current.notificationAlert(options);
      ref.current.value = "";
      setUploadData(initialvalues)
    });
  }
  }

  const changeSenderid=(value)=>{
    senderids=[]
    const payload={
      client_id:user?.client?.toString(),
      channels_type:value.value
    }
    axios.post(CHNL_BY_SENDER,payload).then(res=>{
     
      console.log(res?.message);
      res?.data?.message?.map(item=>{
        
        senderids.push({label:item.senderid,value:item.senderid})
      })
      
    }).catch(e=>console.log(e))
    
  }

  const validate=()=>{
    let error = {}
    if(!uploaddata?.title){
      error.title ="Title Required"
    }else if(uploaddata?.title?.length<4){
      error.title ="Title Too Short"
    }
    if(!uploaddata?.senderid?.value){
      error.senderid ="Senderid Required"
    }
    if(!uploaddata?.date){
      error.date ="Schedule Date Required"
    }
    if(!uploaddata?.channel){
      error.channel ="Channel Required"
    }
    if(!file){
      error.file ="File Required"
    }
    return error;
  }



    const downloadTxtFile = (val,name) => {
      const element = document.createElement("a");
      const file = new Blob([val], {type: 'text/plain'});
      element.href = URL.createObjectURL(file);
      element.download = `${name}_schema.txt`;
      document.body.appendChild(element); // Required for this to work in FireFox
      element.click();
    }

  return (
    <div className="content">
    <Card>
      <CardBody>
      <NotificationAlert ref={notificationAlertRef} />
    <div>
   
      <form enctype="multipart/form-data">
    
        <div className="row">
        <Col sm="2" className="mb-3">
        
                      <MDBInput
                        label="Title "
                        type="text"
                        name="title"
                        value={uploaddata.title}
                        onChange={(e) => setUploadData({...uploaddata,title:e.target.value})}
                      />
                      {errors?.title&&<span style={{color:"red"}}>{errors?.title}</span>}
                    </Col>
                    <Col sm="2" className="mb-4">
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="channel"
                        value={uploaddata.channel}
                        placeholder="Channel"
                        onChange={(value) => {
                          changeSenderid(value)
                          setUploadData(prev=>({...prev,channel:value}));
                        }}
                        options={channelList}
                      />
                      {errors?.channel&&<span style={{color:"red"}}>{errors?.channel}</span>}
                    </Col>
                    <Col sm="2" className="mb-4">
                    
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        name="Select Channel"
                        placeholder="Sender id"
                        value={uploaddata.senderid}
                        onChange={(value) => {
                          setUploadData(prev=>({...prev,senderid:value}));
                        }}
                        options={senderids}
                      />
                      {errors?.senderid&&<span style={{color:"red"}}>{errors?.senderid}</span>}
                    </Col>
                    <Col md='2' sm="12">
                 
                  <ReactDatetime
                    inputProps={{
                      className: "form-control",
                      placeholder: "Date"
                    }}
                    closeOnSelect={true}
                    timeFormat={false}
                    value={uploaddata.date}
                    onChange={(val) =>{setUploadData({...uploaddata,date:val._d})}}
                  />
                  {errors?.date&&<span style={{color:"red"}}>{errors?.date}</span>}
                  
                  </Col>
          <div className="col-md-2">
           
            <input type="file" accept=".xml" ref={ref}  onChange={handleChange} className="form-control" />
            {errors?.file&&<span style={{color:"red"}}>{errors?.file}</span>}
          </div>
          <div className="col-md-2">
         
                <Button
                  color="primary "
                  className="btn btn-icon animation-on-hover"
                  id="tooltipsubmit"
                  type="button"
                  onClick={handleSubmit}
                >
                  <i className="tim-icons icon-double-right" />
                </Button>
                 </div>
        </div>
        </form>
   
    </div>
    <div>
    <Col sm="12" className="scroll-height-350">
      
                <Row>
                <Col md='9' sm="12" className="mt-4">
                  </Col>
                <Col md='3' sm="12" className="mt-2 mb-2">
                    <MDBInput label="Search" type="text" onChange={(e)=>filterData(e)} />
                  </Col>
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th> Channel</th>
                        <th> Sender id </th>
                        <th>schedule Date</th>
                        <th> File </th>
                      </tr>
                    </thead>
                    <tbody>
                      {schemadata?.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <tr>
                            <td>{item.title}</td>
                            <td>{item.channel}</td>
                            <td>{item.senderid}</td>
                            <td>{item.schedule_date}</td>
                            <td><span color="primary" data-placement="top" id="tooltipexcel" type="button"
                                  onClick={() => downloadTxtFile(item.bot_schema,item.channel)}
                         >
                      <i className="tim-icons icon-cloud-download-93" />
                    </span></td>
                              
                            </tr>
                          </React.Fragment>
                        );
                      })}
                
                    </tbody>
                  </Table>
                </Row>
              </Col>
    </div>
    </CardBody>
    </Card>
    </div>
  )
}

export default UploadWorkFlow
